import React from 'react';
import { Form, Icon, Input, Button, Spin } from 'antd';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Nav from '../components/Nav';
import { isAuthenticated } from '../redux/util';
import { transformErrors } from './utils';

const FormItem = Form.Item;

const invokeLogin = async creds => {
  const res = await fetch(
    `${process.env.REACT_APP_DRAFTFAST_API}/rest-auth/registration/`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(creds),
    },
  );

  return res;
};

class LoginForm extends React.Component {
  state = {
    isLoading: false,
    hasServerErrors: false,
    authenticated: false,
    errors: null,
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      this.setState({
        isLoading: true,
        errors: null,
      });

      if (!err) {
        const res = await invokeLogin(values);

        let key;
        let hasServerErrors = true;

        const authenticated = res.status === 201;
        if (authenticated) {
          ({ key } = await res.json());
          hasServerErrors = false;

          localStorage.setItem('dfast_val', key);
          this.setState({
            authenticated,
            hasServerErrors,
            isLoading: false,
          });

          this.props.authenticate({
            username: values.username,
          });
        }

        const hasErrors = res.status === 400;
        if (hasErrors) {
          const objErrors = await res.json();
          this.setState({
            hasServerErrors,
            errors: transformErrors(objErrors),
            isLoading: false,
          });
        }
      }
    });
  };

  render() {
    if (this.state.authenticated) {
      return <Redirect to="/" />;
    }

    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <Nav />
        <div className="login-wrapper">
          <div className="login-form">
            <Form
              onSubmit={this.handleSubmit}
              layout="vertical"
              className="login-form"
            >
              <h3>DraftFast Sign Up</h3>
              <br />
              <FormItem>
                {getFieldDecorator('username', {
                  rules: [
                    { required: true, message: 'Please input your username.' },
                  ],
                })(
                  <Input
                    prefix={
                      <Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />
                    }
                    placeholder="Username"
                  />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('email', {
                  rules: [
                    { required: true, message: 'Please input your e-mail.' },
                  ],
                })(
                  <Input
                    prefix={
                      <Icon type="contacts" style={{ color: 'rgba(0,0,0,.25)' }} />
                    }
                    placeholder="E-mail"
                  />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('password1', {
                  rules: [
                    { required: true, message: 'Please input your password.' },
                  ],
                })(
                  <Input
                    prefix={
                      <Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />
                    }
                    type="password"
                    placeholder="Password"
                  />,
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator('password2', {
                  rules: [
                    {
                      required: true,
                      message: 'Please confirm your password.',
                    },
                  ],
                })(
                  <Input
                    prefix={
                      <Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />
                    }
                    type="password"
                    placeholder="Confirm Password"
                  />,
                )}
              </FormItem>
              {!this.state.isLoading && (
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                >
                  Sign Up
                </Button>
              )}
              {this.state.isLoading && <Spin />}
              {this.state.errors && (
                <div>
                  <br />
                  <div>{this.state.errors}</div>
                  <br />
                  <div>
                    User registration failed. Check the errors above. If this
                    problem persists, contact ben.brostoff@gmail.com.
                  </div>
                </div>
              )}
            </Form>
            <b>
              Accounts are and will always be totally free unless you decide to
              sign up for premium features.
            </b>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return { authenticated: state && state.authenticated };
};

const mapDispatchToProps = dispatch => ({
  authenticate: id => dispatch(isAuthenticated(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  Form.create()(LoginForm),
);



// WEBPACK FOOTER //
// ./src/user/SignUp.js